module.exports = __webpack_public_path__ + "img/storeOne.5a9e8220.jpg";